import { View } from 'foundations-components/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import ExamAttemptExpiredModal from '../../../components/Modals/StatusUpdateModals/ExamAttemptExpiredModal';
import { useExpiredModalState } from '../examsStores';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExamLayout = ({
  children
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const {
    showExpiredModal,
    setShowExpiredModal
  } = useExpiredModalState();
  return /*#__PURE__*/_jsx(View, {
    borderColor: "border-core-subtle",
    borderRadius: "300",
    borderStyle: isMobile ? 'solid' : undefined,
    borderWidth: isMobile ? '100' : undefined,
    "data-test-id": "exam-container",
    overflow: "hidden",
    children: /*#__PURE__*/_jsxs("div", {
      children: [showExpiredModal && /*#__PURE__*/_jsx(ExamAttemptExpiredModal, {
        onView: () => setShowExpiredModal(false)
      }), children]
    })
  });
};
export default ExamLayout;